"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSingle = DropdownSingle;
var react_1 = __importStar(require("react"));
var OptionsSingle_1 = require("../comps/OptionsSingle");
var SelectDropdown_1 = require("../comps/SelectDropdown");
var SelectTagsInput_1 = require("../comps/SelectTagsInput");
var DisplayCompSingle_1 = require("../comps/DisplayCompSingle");
var handlers_1 = require("../handlers");
var useHideShowOptions_1 = require("../utils/useHideShowOptions");
var useCreateDropdownRefs_1 = require("../utils/useCreateDropdownRefs");
var keywordSearchOptions_1 = require("../utils/keywordSearchOptions");
var getValue_1 = require("../utils/getValue");
var generateOptions_1 = require("../utils/generateOptions");
var useSearchString_1 = require("../utils/useSearchString");
var styled_components_1 = require("styled-components");
var genTagComp_1 = require("../utils/genTagComp");
var BlockLabel_1 = require("../../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../../utils/getBlockLabelProps");
var mixins_1 = require("../../../themes/mixins");
var useHandleClickOutside_1 = require("../../../utils/customHooks/useHandleClickOutside");
var useScreenWidth_1 = require("../../../utils/customHooks/useScreenWidth");
var styled_1 = require("../styled");
// single_multi
// static_dynamic
function DropdownSingle(_a) {
    var optionsAnchor = _a.optionsAnchor, lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, 
    //to restructure: rename to TYPO = 'SANS_3' or something. which can be overridden
    selectClassName = _a.selectClassName, //used to override font size in priimary header
    optionsClassName = _a.optionsClassName, //used to override font size in priimary header
    //used by filters topbar. this is a hack. find another way
    disableSelectTextUpdate = _a.disableSelectTextUpdate, selectStyleOverride = _a.selectStyleOverride, valueProp = _a.value, id = _a.id, parentOnChange = _a.onChange, className = _a.className, style = _a.style, readOnly = _a.readOnly, //
    invert = _a.invert, //
    optionsFn = _a.optionsFn, optionsProp = _a.options, saveValueAsString = _a.saveValueAsString, // used in tci
    isTagsStyle = _a.isTagsStyle, selectConfig = _a.selectConfig, label = _a.label, optionsModalLabel = _a.optionsModalLabel, broadcastShowOptions = _a.broadcastShowOptions, 
    //combobox specific
    isSearchable = _a.isSearchable, //
    searchFieldsConfig = _a.searchFieldsConfig, setFilteredOptionsInParent = _a.setFilteredOptions, setSearchStringInParent = _a.setSearchString, searchStringInParent = _a.searchString, genCustomSelectComp = _a.genCustomSelectComp, placeholder = _a.placeholder, //
    genCreateTagButton = _a.genCreateTagButton, popOutOfOverflowHiddenParent = _a.popOutOfOverflowHiddenParent, S = _a.S, //
    disabled = _a.disabled, //
    tagColor = _a.tagColor, observerRef = _a.observerRef, searchbarPlaceholder = _a.searchbarPlaceholder, _b = _a.alignDropdown, alignDropdown = _b === void 0 ? "left" : _b;
    var theme = (0, styled_components_1.useTheme)();
    var props = arguments[0];
    var value = (0, getValue_1.getValue_SINGLE)({ valueProp: valueProp, optionsFn: optionsFn, options: optionsProp, theme: theme, saveValueAsString: saveValueAsString });
    //1 INIT REFS
    var _c = (0, useCreateDropdownRefs_1.useCreateDropdownRefs)(), selectRef = _c.selectRef, dropdownRef = _c.dropdownRef;
    //2 INIT SHOW OPTIONS STATE
    var _d = (0, useHideShowOptions_1.useHideShowOptions)({
        broadcastShowOptions: broadcastShowOptions
    }), showOptions = _d.showOptions, handleHideOptions = _d.handleHideOptions, handleShowOptions = _d.handleShowOptions;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    //3 INIT DD FOCUS CUSTOM HOOK
    (0, useHandleClickOutside_1.useHandleClickOutside)(dropdownRef, handleHideOptions, { enabled: screenWidth >= (0, mixins_1.getBreakPoint)('sm') });
    //5 PRIMARY CHANGE HANDLER
    var handleSelect = function (newVal) {
        setSearchString('');
        (0, handlers_1.handleSelect_SINGLE)({
            id: id,
            newVal: newVal,
            // prevVal: value,
            // hideShowOtherTextInputOnSelect_SINGLE,
            handleHideOptions: handleHideOptions,
            saveValueAsString: saveValueAsString,
            parentOnChange: parentOnChange
        });
    };
    //-- TAG INPUT SPECIFIC
    var _e = (0, useSearchString_1.useSearchString)({
        searchStringInParent: searchStringInParent,
        setSearchStringInParent: setSearchStringInParent
    }), searchString = _e[0], setSearchString = _e[1];
    var options = (0, react_1.useMemo)(function () {
        var ops = (0, generateOptions_1.generateOptions)({
            options: optionsProp,
            optionsFn: optionsFn,
            theme: theme
        });
        return (!isSearchable && !isTagsStyle)
            ? ops
            : !!observerRef === true //if this exists that means search is being handled on the backend via elastic search
                ? ops
                : (0, keywordSearchOptions_1.keywordSearchOptions)({
                    options: ops,
                    searchString: searchString,
                    searchFieldsConfig: searchFieldsConfig,
                    setFilteredOptionsInParent: setFilteredOptionsInParent,
                });
    }, [optionsProp, optionsFn === null || optionsFn === void 0 ? void 0 : optionsFn.fn, searchString]);
    var genSelectTagsInput = function (ops) {
        if (ops === void 0) { ops = {}; }
        return (react_1.default.createElement(SelectTagsInput_1.SelectTagsInput, { id: id, value: value, invert: invert, handleSelect: handleSelect, searchString: searchString, setSearchString: setSearchString, single_multi: 'single', placeholder: placeholder, S: S, disabled: disabled, showOptions: showOptions, S: S, style: ops.style
            // forceFocus, comp is expecting this
         }));
    };
    var genInputComp = function () {
        return (react_1.default.createElement(styled_1.StyledDropdownRefWrapper, { ref: dropdownRef, id: "StyledDropdownRefWrapper" },
            react_1.default.createElement("div", { ref: selectRef, className: "OKE-Dropdown__Select-wrapper", onClick: disabled ? function () { } : function () {
                    isTagsStyle
                        ? !showOptions && handleShowOptions() //if tagsStyle, then click always shows options
                        : showOptions ? handleHideOptions() : handleShowOptions(); //if dropdowns, then click toggles show/hide
                } }, isTagsStyle ? genSelectTagsInput() : (react_1.default.createElement(SelectDropdown_1.SelectDropdown, { invert: invert, value: value, placeholder: placeholder, genCustomSelectComp: genCustomSelectComp, selectClassName: selectClassName, selectStyleOverride: selectStyleOverride, showOptions: showOptions, disableSelectTextUpdate: disableSelectTextUpdate, selectConfig: selectConfig, S: S, disabled: disabled }))),
            react_1.default.createElement(OptionsSingle_1.OptionsSingle, { searchbarPlaceholder: searchbarPlaceholder, observerRef: observerRef, lightboxHeight: lightboxHeight, lightboxStyle: lightboxStyle, optionsAnchor: optionsAnchor, searchString: searchString, setSearchString: setSearchString, id: id, optionsClassName: optionsClassName, label: label, value: value, relativeToRef: selectRef, invert: invert, showOptions: showOptions, handleHideOptions: handleHideOptions, handleSelect: handleSelect, options: options, optionsFn: optionsFn, optionsModalLabel: optionsModalLabel, 
                //combobox specific
                isSearchable: isTagsStyle ? false : isSearchable, alignDropdown: alignDropdown, genCreateTagButton: genCreateTagButton, SelectComp: isTagsStyle && genSelectTagsInput({ style: { position: 'sticky', top: 0, zIndex: 1000 } }), S: S, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent })));
    };
    var genDisplayComp = function () {
        if (!value)
            return null;
        return isTagsStyle ? (react_1.default.createElement(styled_1.StyledTagsInputWrapper, null, (0, genTagComp_1.genTagComp)(id, value, { display: true, invert: invert, theme: theme, color: tagColor }))) : (react_1.default.createElement(DisplayCompSingle_1.DisplayCompSingle, { value: value, invert: invert, S: S }));
    };
    return (react_1.default.createElement("div", { className: "OKE-Dropdown ".concat(className, " OKE-Dropdown--").concat(readOnly ? "displayComp" : "inputComp", " ").concat(invert ? "-invert-" : ""), style: style },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props) /** in other words, props. */)),
        readOnly ? genDisplayComp() : genInputComp()));
}
